import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/pro-light-svg-icons';
import { faStar as faStarSolid } from '@fortawesome/pro-solid-svg-icons';
import { NonInputFieldLabelWrapper } from "./NonFunctionalFieldLabel";
import { withDependentReferenceData } from "../../lib/customHooks/useReferenceData";
export const RatingPreview = withDependentReferenceData(({
  update,
  default: defaultValue,
  read_only,
  value: ratingValue = defaultValue,
  required,
  label,
  errors,
  onBlur
}) => {
  return <NonInputFieldLabelWrapper required={required} label={label} error={errors}>
        <div className={`rating--star--wrapper ${read_only ? 'disabled' : ''}`}>
          {[...Array(5).keys()].map(i => {
        const starNumber = i + 1;
        const filled = starNumber <= ratingValue;
        return <FontAwesomeIcon key={`star-${starNumber}`} className={`rating--star ${filled ? 'filled' : ''}`} icon={!read_only && !filled ? faStar : faStarSolid} onClick={() => {
          const rating = ratingValue == starNumber ? 0 : starNumber;
          update(rating);
          onBlur();
        }} />;
      })}
        </div>
      </NonInputFieldLabelWrapper>;
});